import * as React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import { appTheme } from './styles/appTheme';
import MyRouter from './router/MyRouter';
import { observer } from 'mobx-react';
import { ErrorBoundary } from './router/ErrorBoundary';
import { withEmployee } from './router/Loaders';
import { JssProvider } from 'react-jss';
import { create } from 'jss';
import { jssPreset } from '@material-ui/core/styles';
import createGenerateClassName from "./customClassNameGenerator";


@observer
class App extends React.Component {

  public render() {
    const generateClassName = createGenerateClassName();
    const jss = create({...jssPreset()});
    return (
      <JssProvider jss={jss} generateClassName={generateClassName}>
        <MuiThemeProvider theme={appTheme}>
        { /*CssBaseline kickstart an elegant, consistent, and simple baseline to build upon.*/ }
        <CssBaseline/>
        <ErrorBoundary>
          {
            withEmployee(employee =>
              <MyRouter currentAccount={employee}/>
            )
          }
        </ErrorBoundary>
      </MuiThemeProvider>
      </JssProvider>
    );
  }
}

export default App;
